document.addEventListener("DOMContentLoaded", function () {
  var buttons = document.querySelectorAll(".single_add_to_cart_button");
  buttons.forEach(function (button) {
    var buttonText = button.textContent.trim();
    var dataText = button.getAttribute("data-text");
    var currentValue = button.getAttribute("value");

    if (
      dataText &&
      /^\d+$/.test(currentValue) &&
      button.classList.contains("simple-product")
    ) {
      var textSpan = document.createElement("span");
      textSpan.className = "cta-button__text";
      textSpan.setAttribute("data-text", dataText);
      button.textContent = "";
      button.appendChild(textSpan);
    } else {
      button.setAttribute("value", buttonText);

      var textSpan = document.createElement("span");
      textSpan.className = "cta-button__text";
      textSpan.setAttribute("data-text", buttonText);
      button.textContent = "";
      button.appendChild(textSpan);
    }
  });
});

// Add JavaScript to change placeholder text in product add-ons
document.addEventListener("DOMContentLoaded", function () {
  // Add special-product-input class to ALL WooCommerce addon text inputs
  const allAddonInputs = document.querySelectorAll(
    ".wc-pao-addon-field.wc-pao-addon-custom-text"
  );
  allAddonInputs.forEach(function (input) {
    if (!input.classList.contains("special-product-input")) {
      // Find the parent container with data-addon-name
      const parentContainer = input.closest(".wc-pao-addon-container");
      const addonLabel = parentContainer
        ? parentContainer.querySelector("[data-addon-name]")
        : null;
      const addonName = addonLabel
        ? addonLabel.getAttribute("data-addon-name").toLowerCase()
        : "";

      // Add 'small' class to all inputs EXCEPT Message
      if (addonName === "message") {
        input.classList.add("special-product-input");
      } else {
        input.classList.add("special-product-input", "small");
      }
    }

    // Set placeholder if it doesn't have one
    if (!input.getAttribute("placeholder")) {
      const inputId = input.getAttribute("id");
      const label = document.querySelector(`label[for="${inputId}"]`);
      if (label) {
        let labelText = label.textContent.trim();
        // Remove asterisk for required fields
        labelText = labelText.replace("*", "").trim();

        // Convert to title case (capitalize first letter of each word)
        labelText = labelText.toLowerCase().replace(/\b\w/g, function (char) {
          return char.toUpperCase();
        });

        input.setAttribute("placeholder", labelText);
        input.setAttribute("data-custom-label", labelText);
      }
    }
  });

  // Give every product add-on <select> the theme's floating-label treatment, labelled
  // with the add-on's own name.
  //
  // This used to be hardcoded per add-on ("Cutting / Eating Time?" and "Chocolate
  // Plaque"), so any other add-on select fell through to Product Add-ons' generic
  // "Select an option..." / "None" placeholder and ended up with no usable label at all
  // — visible on the restored global groups (e.g. Cake Filling). Driving it from
  // data-addon-name covers every add-on, including ones added later in the admin.
  //
  // Image-swatch add-ons are skipped: Product Add-ons hides their <select> (see
  // .wc-pao-addon-image-swatch-select in the plugin's frontend.css) and shows clickable
  // swatches instead, so those get a visible heading from .wc-pao-addon-name via CSS
  // rather than a floating label on a hidden field.
  document.querySelectorAll(".wc-pao-addon-container").forEach(function (container) {
    const select = container.querySelector("select.wc-pao-addon-field");
    if (!select || select.classList.contains("wc-pao-addon-image-swatch-select")) {
      return;
    }

    const nameEl = container.querySelector("[data-addon-name]");
    const addonName = nameEl ? nameEl.getAttribute("data-addon-name") : "";
    if (!addonName) {
      return;
    }

    select.classList.add("special-product-dropdown");

    // A trailing "?" reads badly as a field label ("Cutting / Eating Time?" becomes
    // "Cutting / Eating Time"); the required asterisk is appended separately by the
    // BRU2402 pass below.
    const label = addonName.replace(/\s*\?\s*$/, "");

    const placeholder = select.querySelector('option[value=""]');
    if (placeholder) {
      placeholder.textContent = label;
    }
    select.dataset.label = label;
  });
});

//Add custom styling and behavior for selects and text inputs
document.addEventListener("DOMContentLoaded", function () {
  // Use setTimeout to ensure this runs after all other ready handlers
  setTimeout(function () {
    // Process dropdowns
    processSpecialDropdowns();

    // Process text inputs
    processSpecialInputs();

    // Function to process all dropdowns
    function processSpecialDropdowns() {
      // Target all variation selects and special-product-dropdown class in both simple and variable products
      const specialDropdowns = document.querySelectorAll(
        "select.special-product-dropdown, .variations select[name^='attribute_'], .cart select[name^='attribute_']"
      );

      if (!specialDropdowns.length) {
      } else {
        // Process each dropdown
        specialDropdowns.forEach(function (select) {
          // Add the special-product-dropdown class if it doesn't have it
          if (!select.classList.contains("special-product-dropdown")) {
            select.classList.add("special-product-dropdown");
          }

          // Generate placeholder text from attribute name
          let attributeName = select.getAttribute("name") || "";
          if (attributeName.startsWith("attribute_")) {
            attributeName = attributeName.replace("attribute_", "");
          }

          // Remove 'pa_' prefix if it exists (for taxonomy attributes)
          attributeName = attributeName.replace("pa_", "");

          // Convert underscores to spaces and capitalize
          attributeName = attributeName.replace(/_/g, " ");
          attributeName = attributeName.replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          });

          // Change placeholder text from "Choose an option" to the attribute name
          const firstOption = select.querySelector('option[value=""]');
          if (
            firstOption &&
            (firstOption.textContent === "Choose an option" ||
              firstOption.textContent === "Choose an option...")
          ) {
            firstOption.textContent = attributeName;
          }

          // Get the default label from the first option or data attribute
          let defaultLabel = select.dataset.label || "";

          // If no data-label is set, try to get it from the first option if it's empty value
          if (!defaultLabel && select.querySelector("option").value === "") {
            defaultLabel = select.querySelector("option").textContent;
          }

          // If still no label, use the generated attribute name
          if (!defaultLabel) {
            defaultLabel = attributeName || "Select";
          }

          // Store the label for future reference
          select.dataset.customLabel = defaultLabel;

          // Skip if already wrapped (to prevent double wrapping)
          if (select.parentElement.classList.contains("select-container")) {
            return;
          }

          // Wrap in a container for positioning context
          const container = document.createElement("div");
          container.className = "select-container";
          select.parentNode.insertBefore(container, select);
          container.appendChild(select);

          // Add a single label element before the select
          const labelSpan = document.createElement("span");
          labelSpan.className = "select-label";
          labelSpan.textContent = defaultLabel;
          container.insertBefore(labelSpan, select);

          // Function to update the appearance
          function updateAppearance() {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption.value) {
              select.classList.add("has-value");
              container.classList.add("has-value");
            } else {
              select.classList.remove("has-value");
              container.classList.remove("has-value");
            }
          }

          // Initialize appearance
          updateAppearance();

          // Listen for changes
          select.addEventListener("change", updateAppearance);
        });

        // For WooCommerce's custom events that might affect any select
        document.body.addEventListener(
          "woocommerce_variation_has_changed",
          function () {
            specialDropdowns.forEach(function (select) {
              const container = select.closest(".select-container");
              if (container) {
                const selectedOption = select.options[select.selectedIndex];
                if (selectedOption.value) {
                  select.classList.add("has-value");
                  container.classList.add("has-value");
                } else {
                  select.classList.remove("has-value");
                  container.classList.remove("has-value");
                }
              }
            });
          }
        );
      }
    }

    // Function to process all text inputs
    function processSpecialInputs() {
      // Target ALL WooCommerce addon text inputs plus any with special-product-input class
      const specialInputs = document.querySelectorAll(
        "input.special-product-input, input.wc-pao-addon-field.wc-pao-addon-custom-text"
      );

      if (!specialInputs.length) {
      } else {
        // Process each input
        specialInputs.forEach(function (input) {
          // Ensure it has the special class
          if (!input.classList.contains("special-product-input")) {
            input.classList.add("special-product-input");
          }

          // Get the label from data attribute or placeholder
          let labelText =
            input.dataset.label || input.getAttribute("placeholder") || "";

          // If still no label, try to find associated label
          if (!labelText) {
            const inputId = input.getAttribute("id");
            const associatedLabel = document.querySelector(
              'label[for="' + inputId + '"]'
            );
            if (associatedLabel) {
              labelText = associatedLabel.textContent.trim();
              // Remove any asterisk for required fields
              labelText = labelText.replace("*", "").trim();
            }
          }

          // If all else fails, use a generic label or the name
          if (!labelText) {
            labelText = input.getAttribute("name") || "Input";
            // Clean up the name
            labelText = labelText.replace("addon-", "").replace(/-/g, " ");
            // Capitalize first letter of each word
            labelText = labelText.replace(/\b\w/g, (l) => l.toUpperCase());
          }

          // Store the label for future reference
          input.dataset.customLabel = labelText;

          // Skip if already wrapped (to prevent double wrapping)
          if (input.parentElement.classList.contains("input-container")) {
            return;
          }

          // Wrap in a container for positioning context
          const container = document.createElement("div");
          container.className = "input-container";
          input.parentNode.insertBefore(container, input);
          container.appendChild(input);

          // Add a single label element before the input
          const labelSpan = document.createElement("span");
          labelSpan.className = "input-label";
          labelSpan.textContent = labelText;
          container.insertBefore(labelSpan, input);

          // Function to update the appearance based on value
          function updateInputAppearance() {
            if (input.value) {
              input.classList.add("has-value");
              container.classList.add("has-value");
            } else {
              // Don't remove classes if the element has focus
              if (document.activeElement !== input) {
                input.classList.remove("has-value");
                container.classList.remove("has-value");
              }
            }
          }

          // Add focus and blur handlers
          input.addEventListener("focus", function () {
            // Always show the label when focused, even if empty
            input.classList.add("has-value");
            container.classList.add("has-value");
          });

          input.addEventListener("blur", function () {
            // Only keep the label visible if there's a value
            if (!input.value) {
              input.classList.remove("has-value");
              container.classList.remove("has-value");
            }
          });

          // Initialize appearance
          updateInputAppearance();

          // Listen for various events that might change the input value
          ["change", "keyup", "input"].forEach(function (eventType) {
            input.addEventListener(eventType, updateInputAppearance);
          });
        });
      }
    }
  }, 10); // A short 10ms delay to ensure DOM is ready
});

// Create the price and stock wrapper

document.addEventListener("DOMContentLoaded", function () {

  // Store the original price range for resetting if needed
  const priceElement = document.querySelector(".price");
  const originalPriceHtml = priceElement ? priceElement.innerHTML : "";

  // Wrap the price in a container div - use consistent naming
  if (priceElement && !priceElement.closest(".price-stock-container")) {
    const container = document.createElement("div");
    container.className = "price-stock-container";
    priceElement.parentNode.insertBefore(container, priceElement);
    container.appendChild(priceElement);
  }

  // Handle both variable and simple products
  const variationForm = document.querySelector(".variations_form");
  const cartForm = document.querySelector("form.cart");


  // For simple products, check stock status immediately
  const productAddonsTotal = document.getElementById("product-addons-total");
  const isSimpleProduct =
    productAddonsTotal &&
    productAddonsTotal.getAttribute("data-type") === "simple";
  const hasStockElement = document.querySelector(
    ".store-availability__add-to-cart-wrapper .stock"
  );


  // Run for simple products OR when there's a stock element in the add-to-cart wrapper
  if ((cartForm && isSimpleProduct) || hasStockElement) {


    const stockStatus =
      document.querySelector(
        ".store-availability__add-to-cart-wrapper .stock"
      ) ||
      document.querySelector(".stock") ||
      document.querySelector(".woocommerce-variation-add-to-cart .stock");

    if (stockStatus) {
      const stockText = stockStatus.textContent.trim();
      const isOutOfStock = stockStatus.classList.contains("out-of-stock");

      let stockHTML = "";
      let stockQuantity = "";
      let stockClass = "";

      if (isOutOfStock) {
        stockHTML = '<p class="stock out-of-stock">Out of stock</p>';
      } else {
        let stockMatch = stockText.match(/(\d+)/);
        let qty = null;

        if (stockMatch) {
          qty = parseInt(stockMatch[1]);
        } else {
          const quantityInput = document.querySelector(
            'input.qty[name="quantity"]'
          );
          if (quantityInput && quantityInput.getAttribute("max")) {
            qty = parseInt(quantityInput.getAttribute("max"));
          }
        }

        if (qty !== null && qty > 0) {
          if (qty < 5) {
            stockQuantity = qty + " left in stock";
            stockClass = "low-stock";
          } else {
            stockQuantity = "In stock";
            stockClass = "in-stock";
          }
        } else if (qty === 0) {
          stockQuantity = "Out of stock";
          stockClass = "out-of-stock";
        } else {
          stockQuantity = "In stock";
          stockClass = "in-stock";
        }

        stockHTML =
          '<p class="stock ' + stockClass + '">' + stockQuantity + "</p>";
      }

      const stockStatusDiv = document.createElement("div");
      stockStatusDiv.className = "variation-stock-status";
      stockStatusDiv.style.opacity = "0";
      stockStatusDiv.style.transition = "opacity 0.3s ease";
      stockStatusDiv.innerHTML = stockHTML;

      stockStatus.remove();

      const priceStockContainer = document.querySelector(
        ".price-stock-container"
      );

      if (priceStockContainer) {
        priceStockContainer.appendChild(stockStatusDiv);

        setTimeout(function () {
          stockStatusDiv.style.opacity = "1";
        }, 150);
      } 
    }
  }


  // Listen for variation changes (variable products only)
  if (variationForm) {
    // Theme-owned namespace, so it cannot collide with WooCommerce's jQuery event of
    // the same name -- see the bridge in addWooCommerceEventListeners().
    variationForm.addEventListener("arcadian:show_variation", function (event) {

      const variation =
        event.detail && event.detail.variation
          ? event.detail.variation
          : event.variation;

      const allVariationsSelected = checkAllVariationsSelected();

      if (variation && allVariationsSelected) {

        // ===== HANDLE PRICE DISPLAY (works with OR without price_html) =====
        const priceEl = document.querySelector(".price");
        if (priceEl) {
          // Check if user is wholesale customer and wholesale price data exists
          const isWholesaleCustomer = document.body.classList.contains('wholesale-customer') ||
                                      (typeof wwpUserData !== 'undefined' && wwpUserData.is_wholesale_customer);

          if (isWholesaleCustomer && variation.wholesale_price) {
            // Wholesale customer - construct wholesale price HTML
            let wholesalePriceHTML = '<span style="display: block;" class="wholesale_price_container">';
            wholesalePriceHTML += '<span class="wholesale_price_title">Wholesale Price:</span> ';
            wholesalePriceHTML += '<span class="wholesale_price">';
            wholesalePriceHTML += '<span class="woocommerce-Price-amount amount">';
            wholesalePriceHTML += '<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + parseFloat(variation.wholesale_price).toFixed(2) + '</bdi>';
            wholesalePriceHTML += '</span></span></span>';

            // Always show original price as crossed out for wholesale customers
            const originalPrice = variation.display_regular_price || variation.display_price;
            if (originalPrice) {
              wholesalePriceHTML = '<del class="original-computed-price">' +
                '<span class="woocommerce-Price-amount amount">' +
                '<bdi><span class="woocommerce-Price-currencySymbol">$</span>' + parseFloat(originalPrice).toFixed(2) + '</bdi>' +
                '</span></del> ' + wholesalePriceHTML;
            }

            priceEl.innerHTML = '<p class="price">' + wholesalePriceHTML + '</p>';
          } else if (variation.price_html) {
            // Case 1: price_html exists - use it directly
            priceEl.innerHTML = variation.price_html;
          } else if (
            variation.display_price ||
            variation.display_regular_price
          ) {
            // Case 2: No price_html - build it manually from price data
            let priceHTML = '<p class="price">';

            // Check if there's a sale price
            if (
              variation.display_price &&
              variation.display_regular_price &&
              variation.display_price < variation.display_regular_price
            ) {
              // Sale price display
              const regularPrice = parseFloat(
                variation.display_regular_price
              ).toFixed(2);
              const salePrice = parseFloat(variation.display_price).toFixed(2);

              priceHTML +=
                '<del><span class="woocommerce-Price-amount amount">';
              priceHTML +=
                '<bdi><span class="woocommerce-Price-currencySymbol">$</span>' +
                regularPrice +
                "</bdi>";
              priceHTML += "</span></del> ";
              priceHTML +=
                '<ins><span class="woocommerce-Price-amount amount">';
              priceHTML +=
                '<bdi><span class="woocommerce-Price-currencySymbol">$</span>' +
                salePrice +
                "</bdi>";
              priceHTML += "</span></ins>";
            } else {
              // Regular price display
              const price = parseFloat(
                variation.display_price || variation.display_regular_price
              ).toFixed(2);
              priceHTML += '<span class="woocommerce-Price-amount amount">';
              priceHTML +=
                '<bdi><span class="woocommerce-Price-currencySymbol">$</span>' +
                price +
                "</bdi>";
              priceHTML += "</span>";
            }

            priceHTML += "</p>";
            priceEl.innerHTML = priceHTML;
          }
        }

        // ===== HANDLE STOCK DISPLAY (always runs regardless of price) =====
        let stockStatus = "";

        if (variation.is_in_stock) {
          let stockQuantity = "";
          let stockClass = "in-stock";

          // Check stock quantity
          if (variation.max_qty !== "" && variation.max_qty !== undefined) {
            const qty = parseInt(variation.max_qty);

            if (qty === 0) {
              stockQuantity = "Out of stock";
              stockClass = "out-of-stock";
            } else if (qty < 5) {
              stockQuantity = qty + " left in stock";
              stockClass = "low-stock";
            } else {
              stockQuantity = "In stock";
              stockClass = "in-stock";
            }
          } else {
            stockQuantity = "In stock";
            stockClass = "in-stock";
          }

          stockStatus =
            '<p class="stock ' + stockClass + '">' + stockQuantity + "</p>";
        } else {
          stockStatus = '<p class="stock out-of-stock">Out of stock</p>';
        }

        // Remove any existing stock status
        const existingStockStatus = document.querySelector(
          ".variation-stock-status"
        );
        if (existingStockStatus) {
          existingStockStatus.remove();
        }

        // Create the stock status div
        const stockStatusDiv = document.createElement("div");
        stockStatusDiv.className = "variation-stock-status";
        stockStatusDiv.style.opacity = "0";
        stockStatusDiv.style.transition = "opacity 0.3s ease";
        stockStatusDiv.innerHTML = stockStatus;

        // Ensure we have a container
        let priceStockContainer = document.querySelector(
          ".price-stock-container"
        );

        if (!priceStockContainer) {
          const priceElement = document.querySelector(".price");
          if (priceElement) {
            const container = document.createElement("div");
            container.className = "price-stock-container";
            priceElement.parentNode.insertBefore(container, priceElement);
            container.appendChild(priceElement);
            priceStockContainer = container;
          }
        }

        if (priceStockContainer) {
          priceStockContainer.appendChild(stockStatusDiv);

          // Show stock status with fade-in
          setTimeout(function () {
            stockStatusDiv.style.opacity = "1";
          }, 150);
        } else {
          console.error("✗ Could not find/create price-stock-container!");
        }
      }
    });

    // When variations are hidden (reset)
    variationForm.addEventListener("arcadian:hide_variation", function () {

      const priceEl = document.querySelector(".price");
      if (priceEl) {
        priceEl.innerHTML = originalPriceHtml;
      }

      const stockStatus = document.querySelector(".variation-stock-status");
      if (stockStatus) {
        stockStatus.remove();
      }
    });

    // Clear button
    const resetButton = document.querySelector(".reset_variations");
    if (resetButton) {
      resetButton.addEventListener("click", function () {

        const priceEl = document.querySelector(".price");
        if (priceEl) {
          priceEl.innerHTML = originalPriceHtml;
        }

        const stockStatus = document.querySelector(".variation-stock-status");
        if (stockStatus) {
          stockStatus.remove();
        }
      });
    }
  }

  /**
   * jQuery bridge.
   *
   * Re-emits WooCommerce's jQuery variation events as native DOM events so the
   * non-jQuery code above can listen for them.
   *
   * The native events MUST NOT reuse WooCommerce's event names. jQuery also
   * listens for native events, so dispatching a native "show_variation" feeds
   * straight back into every jQuery show_variation handler -- but a native
   * CustomEvent carries no jQuery extra-args, so those handlers re-run with
   * `variation` and `purchasable` undefined. WooCommerce's own onShow() then
   * reads purchasable as falsy and re-disables the Add to Cart button it had
   * just enabled, and WooCommerce Min/Max Quantities throws on the empty
   * payload. A theme-owned prefix keeps the two systems apart by construction.
   */
  function addWooCommerceEventListeners() {
    if (typeof jQuery !== "undefined") {
      jQuery(document).on(
        "show_variation",
        "form.variations_form",
        function (event, variation) {
          try {
            const customEvent = new CustomEvent("arcadian:show_variation", {
              detail: { variation: variation },
            });
            this.dispatchEvent(customEvent);
          } catch (error) {
          }
        }
      );

      jQuery(document).on(
        "hide_variation",
        "form.variations_form",
        function () {
          try {
            const customEvent = new CustomEvent("arcadian:hide_variation");
            this.dispatchEvent(customEvent);
          } catch (error) {
          }
        }
      );
    }
  }

  // Function to check if all required variations are selected
  function checkAllVariationsSelected() {
    if (!variationForm) return false;

    const variationSelects = variationForm.querySelectorAll(
      'select[name^="attribute_"]'
    );

    for (let select of variationSelects) {
      if (!select.value || select.value === "") {
        return false;
      }
    }

    return variationSelects.length > 0;
  }

  // Loading state function
  function showStockLoadingState() {

    const existingStockStatus = document.querySelector(
      ".variation-stock-status"
    );
    if (existingStockStatus) {
      existingStockStatus.remove();
    }

    const loadingDiv = document.createElement("div");
    loadingDiv.className = "variation-stock-status stock-loading";
    loadingDiv.style.opacity = "0.6";
    loadingDiv.innerHTML = '<p class="stock">Checking stock...</p>';

    let priceStockContainer = document.querySelector(".price-stock-container");
    if (priceStockContainer) {
      priceStockContainer.appendChild(loadingDiv);
    } else {
      console.error("✗ No price-stock-container for loading state!");
    }

    setTimeout(function () {
      const stillLoading = document.querySelector(".stock-loading");
      if (stillLoading) {
        stillLoading.remove();
        console.warn("⚠️ Stock check timed out - loading state removed");
      }
    }, 3000);
  }

  // Set up event listeners
  addWooCommerceEventListeners();
  setTimeout(addWooCommerceEventListeners, 100);

  // Direct select listeners
  if (variationForm) {
    const variationSelects = variationForm.querySelectorAll(
      'select[name^="attribute_"]'
    );


    variationSelects.forEach(function (select) {
      select.addEventListener("change", function () {

        const existingStockStatus = document.querySelector(
          ".variation-stock-status"
        );
        if (existingStockStatus) {
          existingStockStatus.remove();
        }

        const allSelected = checkAllVariationsSelected();

        if (allSelected) {
          showStockLoadingState();
        }
      });
    });
  }
});

// Shared required-field markers for product add-ons, used by the BRU2402 static
// asterisk pass below and by the BRU-1003 conditional Message field, which has to
// add and remove them as the field is revealed and hidden. File scope: gulp
// concatenates js/**/*.js into one bundle, so these are visible to both blocks.

// Append a red `<span class="required-asterisk">*</span>` to a custom floating label.
// Uses an element (not a " *" text append) so the asterisk can be coloured $error via
// CSS. Idempotent: skips if the label already has a `.required-asterisk` child.
function appendRequiredAsterisk(label) {
  if (!label || label.querySelector(".required-asterisk")) {
    return;
  }
  const asterisk = document.createElement("span");
  asterisk.className = "required-asterisk";
  asterisk.setAttribute("aria-hidden", "true");
  asterisk.textContent = "*";
  label.appendChild(document.createTextNode(" "));
  label.appendChild(asterisk);
}

// Inverse of appendRequiredAsterisk. Also drops the " " text node inserted before the
// asterisk so repeated show/hide cycles can't accumulate whitespace in the label.
function removeRequiredAsterisk(label) {
  if (!label) {
    return;
  }
  const asterisk = label.querySelector(".required-asterisk");
  if (!asterisk) {
    return;
  }
  const spacer = asterisk.previousSibling;
  if (spacer && spacer.nodeType === Node.TEXT_NODE && !spacer.textContent.trim()) {
    spacer.remove();
  }
  asterisk.remove();
}

// Append a plain " *" to a native <select> placeholder option. Browsers can't colour
// part of an <option>'s text, so this asterisk stays the option's own colour (per
// Arran: "dont worry about the option"). Idempotent on the trailing "*".
function appendOptionAsterisk(option) {
  if (option && option.textContent.indexOf("*") === -1) {
    option.textContent = option.textContent.trim() + " *";
  }
}

// Text inputs show their required marker in the placeholder (the floating label is
// only visible once the field has focus or a value), so mark both.
function appendPlaceholderAsterisk(input) {
  if (!input) {
    return;
  }
  const placeholder = input.getAttribute("placeholder") || "";
  if (placeholder && placeholder.indexOf("*") === -1) {
    input.setAttribute("placeholder", placeholder.trim() + " *");
  }
}

function removePlaceholderAsterisk(input) {
  if (!input) {
    return;
  }
  const placeholder = input.getAttribute("placeholder") || "";
  if (placeholder.indexOf("*") !== -1) {
    input.setAttribute("placeholder", placeholder.replace(/\s*\*\s*$/, ""));
  }
}

// BRU2402: Indicate required product add-ons (e.g. Size, Cutting / Eating Time) with an
// asterisk after the field name. The PHP `get_product_addons` filter flags these add-ons
// as required, which adds the `wc-pao-required-addon` class to their container.
document.addEventListener("DOMContentLoaded", function () {
  // Run after the dropdown/input label builders (which run on a short timeout) so the
  // visible placeholder/label text already exists, then append the asterisk idempotently.
  setTimeout(function () {
    document
      .querySelectorAll(".wc-pao-addon-container.wc-pao-required-addon")
      .forEach(function (container) {
        // Native select placeholder (shown before a selection is made).
        appendOptionAsterisk(container.querySelector('select option[value=""]'));

        // Custom floating label (shown once a value is selected).
        appendRequiredAsterisk(
          container.querySelector(".select-label, .input-label")
        );

        // Text input placeholder, if this required add-on is a text field.
        appendPlaceholderAsterisk(
          container.querySelector("input.wc-pao-addon-field")
        );
      });

    // BRU2402: "Size" is a WooCommerce *variation attribute* (pa_size), not a product
    // add-on, so it isn't inside a .wc-pao-required-addon container and the loop above
    // skips it. Append the required asterisk to its placeholder option and its custom
    // floating label (built by processSpecialDropdowns) so "Size" reads "Size *".
    document
      .querySelectorAll(
        'select[name="attribute_pa_size"], select[name="attribute_size"], select#pa_size'
      )
      .forEach(function (sizeSelect) {
        appendOptionAsterisk(sizeSelect.querySelector('option[value=""]'));

        const container = sizeSelect.closest(".select-container");
        appendRequiredAsterisk(
          container ? container.querySelector(".select-label") : null
        );
      });
  }, 60);
});

//add project single accordions
document.addEventListener("DOMContentLoaded", function () {
  // Toggle accordion content
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach(function (header) {
    header.addEventListener("click", function () {
      // Toggle 'active' class on the header itself
      this.classList.toggle("active");

      // Toggle 'active' class on the parent element
      this.parentElement.classList.toggle("active");
    });
  });
});

// BRU-1003: Chocolate Plaque / Message conditional pairing.
//
// A message is only meaningful when there's a plaque to write it on, so the "Message"
// add-on stays hidden until the "Chocolate Plaque" dropdown has a value, and becomes
// required once it does. Hiding also clears the field, so a message typed before the
// plaque was reset can never ride along in the POST body. This is UX only — the
// authoritative rule is brunetti_validate_plaque_message_pair() in brunetti-ecommerce.
//
// Both add-ons come from the global add-on group, whose generated field names are
// per-product (addon-<product_id>-<index>), so we match on the stable data-addon-name.
// Add-on containers are rendered once server-side and are never rebuilt on a variation
// change (see addons.js `found_variation`), so one binding covers simple and variable
// products alike.
document.addEventListener("DOMContentLoaded", function () {
  function addonContainer(addonName) {
    const label = document.querySelector('[data-addon-name="' + addonName + '"]');
    return label ? label.closest(".wc-pao-addon-container") : null;
  }

  const plaqueContainer = addonContainer("Chocolate Plaque");
  const messageContainer = addonContainer("Message");
  if (!plaqueContainer || !messageContainer) {
    return;
  }

  const plaqueSelect = plaqueContainer.querySelector("select.wc-pao-addon-field");
  const messageInput = messageContainer.querySelector("input.wc-pao-addon-field");
  if (!plaqueSelect || !messageInput) {
    return;
  }

  // Product Add-ons decides whether a field is required by reading its
  // `data-restrictions` JSON (see Validation.prototype.validateAddon in the plugin's
  // addons.js), and its own submit handler blocks add-to-cart and prints the red
  // "Please enter some text in this field." notice when a required field is empty.
  // Flipping that flag as the plaque selection changes therefore gives Message exactly
  // the same behaviour and styling as the Cutting / Eating Time field, rather than
  // reimplementing a parallel validation UI.
  //
  // The base restrictions (here: the 35-character limit) are preserved so toggling
  // required-ness never drops the plugin's own rules.
  let baseRestrictions = {};
  try {
    baseRestrictions =
      JSON.parse(messageInput.getAttribute("data-restrictions") || "{}") || {};
  } catch (error) {
    baseRestrictions = {};
  }
  delete baseRestrictions.required;

  function setMessageRequired(required) {
    const restrictions = Object.assign({}, baseRestrictions);
    if (required) {
      restrictions.required = "yes";
    }

    messageInput.setAttribute("data-restrictions", JSON.stringify(restrictions));

    // jQuery caches data-* on first read, so the attribute alone isn't enough —
    // Product Add-ons would keep seeing the original value.
    if (window.jQuery) {
      window.jQuery(messageInput).data("restrictions", restrictions);
    }

    if (!required) {
      // Drop any notice left over from a previous attempt, so clearing the plaque
      // doesn't leave a red error hanging under a field that's on its way out.
      const notice = messageContainer.querySelector(".wc-pao-validation-notice");
      if (notice) {
        notice.remove();
      }
    }
  }

  // The container slides open and closed rather than snapping. Everything is done
  // with inline styles: the theme's add-on layout rules are nested five levels deep
  // (.single-product … .single_variation_wrap .wc-pao-addon-container), so a utility
  // class would lose the specificity fight over margin — and inline styles behave the
  // same on the simple-product page, which isn't inside that wrapper at all.
  const MOTION_MS = 260;

  // Read the stylesheet's own spacing once, while the field is still in its natural
  // state, so expanding restores whatever the theme gives it instead of a hardcoded
  // value.
  const naturalStyle = window.getComputedStyle(messageContainer);
  const naturalMarginTop = naturalStyle.marginTop;
  const naturalMarginBottom = naturalStyle.marginBottom;

  let motionTimer = null;

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  // How much taller the form is with the field collapsed-but-in-flow than with it
  // display:none.
  //
  // Adjacent add-ons have vertical margins that collapse into a single gap when
  // nothing sits between them. A zero-height box would normally collapse through too,
  // but the slide needs `overflow: hidden` to clip its contents, and that establishes
  // a block formatting context which blocks margin collapsing. So the collapsed
  // in-flow field leaves plaque-margin + cut-margin (4rem) where display:none leaves
  // the collapsed 2rem — and applying display:none at the end of the slide would snap
  // the layout up by the difference.
  //
  // Measuring it here (rather than assuming 2rem) means the compensation stays correct
  // if the theme's add-on spacing ever changes, and is 0 on any layout that doesn't
  // margin-collapse at all, e.g. a flex or grid parent.
  function measureMarginCollapseOffset() {
    const style = messageContainer.style;
    const saved = {
      display: style.display,
      height: style.height,
      marginTop: style.marginTop,
      marginBottom: style.marginBottom,
      overflow: style.overflow,
      transition: style.transition,
    };
    const parent = messageContainer.parentNode;

    style.transition = "none";

    style.display = "none";
    const outOfFlow = parent.getBoundingClientRect().height;

    style.display = "";
    style.overflow = "hidden";
    style.height = "0px";
    style.marginTop = "0px";
    style.marginBottom = "0px";
    const inFlow = parent.getBoundingClientRect().height;

    Object.assign(style, saved);
    void messageContainer.offsetHeight; // commit the restore before anything animates

    return Math.max(0, Math.round(inFlow - outOfFlow));
  }

  const marginCollapseOffset = measureMarginCollapseOffset();

  // Applies the resting collapsed geometry. Kept as inline styles (rather than cleared)
  // so that re-expanding starts from exactly this geometry and doesn't jump.
  function applyCollapsedStyles() {
    const style = messageContainer.style;
    style.overflow = "hidden";
    style.height = "0px";
    style.marginTop = "0px";
    // Negative bottom margin absorbs the margin-collapsing difference, so the moment
    // display:none is applied the surrounding layout does not shift at all.
    style.marginBottom = -marginCollapseOffset + "px";
    style.opacity = "0";
  }

  // Hands height and spacing back to the stylesheet so the open field reflows normally
  // (e.g. if a validation notice appears beneath it).
  function clearMotionStyles() {
    const style = messageContainer.style;
    style.transition = "";
    style.height = "";
    style.marginTop = "";
    style.marginBottom = "";
    style.opacity = "";
    style.overflow = "";
  }

  // `animate` is false for the very first call, so the field starts collapsed on load
  // instead of visibly sliding shut.
  function setCollapsed(collapsed, animate) {
    const style = messageContainer.style;
    const shouldAnimate = animate && !prefersReducedMotion();

    window.clearTimeout(motionTimer);

    if (!shouldAnimate) {
      if (collapsed) {
        applyCollapsedStyles();
        style.transition = "";
        style.display = "none";
      } else {
        clearMotionStyles();
        style.display = "";
      }
      return;
    }

    // Measure BEFORE touching display. A collapsed field is display:none and reports
    // 0 here, which is the correct starting point for an expand; measuring after
    // display:"" would report the full natural height and leave nothing to tween.
    // Mid-animation this reports the current height, so an interrupted slide picks up
    // from where it got to.
    const startHeight = messageContainer.getBoundingClientRect().height;

    // Back into the flow so scrollHeight can be read (it is 0 while display:none).
    style.display = "";
    style.overflow = "hidden";

    // Start from concrete values so the browser has two numbers to tween between;
    // "auto" is not an animatable value.
    style.height = startHeight + "px";
    style.transition =
      "height " + MOTION_MS + "ms ease, " +
      "margin-top " + MOTION_MS + "ms ease, " +
      "margin-bottom " + MOTION_MS + "ms ease, " +
      "opacity " + Math.round(MOTION_MS * 0.7) + "ms ease";

    // Force a reflow so the starting geometry is committed before the target is set,
    // otherwise the browser collapses both writes into one frame and nothing tweens.
    void messageContainer.offsetHeight;

    if (collapsed) {
      applyCollapsedStyles();
    } else {
      style.height = messageContainer.scrollHeight + "px";
      style.marginTop = naturalMarginTop;
      style.marginBottom = naturalMarginBottom;
      style.opacity = "1";
    }

    motionTimer = window.setTimeout(function () {
      style.transition = "";
      if (collapsed) {
        // Geometry already matches display:none exactly, so this swap is invisible.
        style.display = "none";
        return;
      }
      clearMotionStyles();
      style.display = "";
    }, MOTION_MS);
  }

  function syncMessageField(animate) {
    const hasPlaque = plaqueSelect.value !== "";

    setCollapsed(!hasPlaque, animate);
    setMessageRequired(hasPlaque);
    messageContainer.classList.toggle("wc-pao-required-addon", hasPlaque);
    messageInput.setAttribute("aria-required", hasPlaque ? "true" : "false");

    const floatingLabel = messageContainer.querySelector(".input-label");

    if (hasPlaque) {
      appendRequiredAsterisk(floatingLabel);
      appendPlaceholderAsterisk(messageInput);
      return;
    }

    if (messageInput.value !== "") {
      messageInput.value = "";
      // Let Product Add-ons re-run its totals/validation and let the theme's
      // floating-label code drop its `has-value` state.
      messageInput.dispatchEvent(new Event("input", { bubbles: true }));
      messageInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    removeRequiredAsterisk(floatingLabel);
    removePlaceholderAsterisk(messageInput);
  }

  plaqueSelect.addEventListener("change", function () {
    syncMessageField(true);
  });

  // Collapse straight away, un-animated, so the field isn't briefly visible on load.
  // Re-sync at 80ms — after the floating-label builders (10ms) and the BRU2402
  // asterisk pass (60ms) — so the `.input-label` span this decorates already exists.
  // syncMessageField is idempotent and no-ops on a missing label, so running it twice
  // is safe.
  syncMessageField(false);
  setTimeout(function () {
    syncMessageField(false);
  }, 80);
});
